import { render } from "./courtPayments.vue?vue&type=template&id=3247520a"
import script from "./courtPayments.vue?vue&type=script&lang=js"
export * from "./courtPayments.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__